/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Col, Container, FloatingLabel, Form, Row, Stack } from 'react-bootstrap';
import { useStores } from 'services/useStore';
import { useTranslation } from 'react-i18next';
import { TSuccessResponse } from 'services/Api';
import { observer } from 'mobx-react';
import { ProjectTypes, TProjectLORE, TProjectSettings } from 'stores/ProjectsStore';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'components/App/App';
import ImageList from 'components/Heplers/ImageList';
import { CashCoin, Plus, Trash } from 'react-bootstrap-icons';
import { TUserRole, UserStatus } from 'stores/SessionStore';
import AITextButton from 'components/Buttons/AITextButton';
import LinkList from 'components/Heplers/LinkList';
import InfoButton from 'components/Heplers/InfoButton';
import UserFind from 'components/Heplers/UserFind';
import UserShow from 'components/Heplers/UserShow';
//import styles from './style.module.scss';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let timer: any;

export type TCheckResult = {
  elements?: { [key: string]: boolean | string | number };
  error?: string;
};

const ProjectEdit: React.FC = observer(() => {
  const pId = useParams().params || 0;
  const history = useNavigate();
  const { t } = useTranslation();
  const { api, projectStore, sessionStore } = useStores();
  api.noLogin();
  if (!api.isManager(+pId, true)) {
    history(ROUTES.projects);
  }
  const [projectId, setProjectId] = useState(+pId);
  const [validated, setValidated] = useState(false);
  const [name, setName] = useState('');
  const [title, setTitle] = useState('');
  const [mg, setMG] = useState('');
  const [status, setStatus] = useState('');
  const [newRoles, setNewRoles] = useState(0);
  const [roles, setRoles] = useState<TUserRole[]>();
  const [successText, setSuccessText] = useState('');
  const [imgList, setImgList] = useState([] as string[]);
  const [userId, setUserId] = useState(0);
  const [useImageAI, setuseImageAI] = useState(false);
  const [canSave, setCanSave] = useState<string>('');
  const [useAI, setUseAI] = useState(false);
  const [isAdmin, setiIsAdmin] = useState(false);
  const [useGSH, setUseGSH] = useState(false);
  const [gsh, setGSH] = useState<string>('');
  const [pricing, setPricing] = useState<string | false>();
  const [defaultImagePrompt, setDefaultImagePrompt] = useState<string>();
  const [lang, setLang] = useState<string>('ua');
  const [settings, setSettings] = useState<TProjectSettings>();
  const [llmModel, setLlmModel] = useState<string>('none');
  const [modelList, setModelList] = useState<any[]>([]);

  const [llmOpenAIKey, setLlmOpenAIKey] = useState<string>();
  const [llmGoogleKey, setLlmGoogleKey] = useState<string>();
  const [llmAnthropicKey, setLlmAnthropicKey] = useState<string>();

  const [imageStyle, setImageStyle] = useState<string>('');
  const [stylesList, setStylesList] = useState<string[]>([]);
  const [random, setRandom] = useState(0);

  const onTitle = useCallback((value: string) => {
    setTitle(value);
  }, []);

  const update = () => {
    if (projectId) {
      api.getProjects(projectId).then((data) => {
        const project = data as any;
        setName(project.project_name);
        setTitle(project.project_title);
        setMG(project.project_mg);
        setStatus(project.project_status);
        setUserId(project.user_id);
        setRoles(project.user_role);
        setPricing(project.project_pricing);
        const settingsData: TProjectSettings =
          typeof project.project_settings === 'string'
            ? JSON.parse(project.project_settings.replaceAll("'", '"') || '{}')
            : project.project_settings || {};
        setSettings(settingsData);
        setuseImageAI(settingsData.useImageAI || false);
        setUseAI(settingsData.useAI || false);
        setUseGSH(!!settingsData.gsh);
        setGSH(settingsData.gsh || '');
        setLlmModel(api.settings.serverSettings?.llm_model || settingsData.llm_model || 'none');
        setLlmOpenAIKey(settingsData.llm_openai_key || '');
        setLlmGoogleKey(settingsData.llm_google_key || '');
        setLlmAnthropicKey(settingsData.llm_anthropic_key || '');
        setLang(settingsData.lang || 'ua');
        setDefaultImagePrompt(settingsData.defaultImagePrompt || '');
        setImageStyle(settingsData.imageStyle || 'none');
        setiIsAdmin(
          project.user_id === sessionStore.session.user_id ||
            sessionStore.session.user_status === UserStatus.Admin
        );
        projectStore.update(project);
        if (project.project_images) setImgList(project.project_images);
        else setImgList([]);
      });
    }
  };

  const updateImages = useCallback(() => {
    api.getProjects(projectId).then((data) => {
      const project = data as TProjectLORE;
      if (project.project_images) setImgList(project.project_images);
      else setImgList([]);
    });
  }, []);

  const selectPricing = (priceName: string | false) => {
    console.log(priceName);
    setPricing(priceName);
    if (priceName === 'free') {
      setuseImageAI(false);
    }
    if (priceName === false) {
      setCanSave('projectForm.selectPriceAlert');
      return;
    }
    if (
      sessionStore.session.user_balance <
      api.settings.pricing[priceName as keyof typeof api.settings.pricing]
    ) {
      setCanSave('projectForm.priceAlert');
    } else {
      setCanSave('');
    }
  };

  const showPricingWindow = () => {
    api.togglePricingGenerateDialog(selectPricing, pricing);
  };

  useEffect(() => {
    update();
    //if (!projectId) api.togglePricingGenerateDialog(selectPricing);
    api.getStylesForGenerateImage().then((list) => setStylesList(list));
    fetch(api.settings.url.server + 'ai/models')
      .then(res => res.json())
      .then(data => setModelList(data))
      .catch(err => console.error(err));
    return () => {
      if (timer) clearTimeout(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSettings({
      ...settings,
      useImageAI,
      useAI,
      lang,
      llm_model: llmModel,
      llm_openai_key: llmOpenAIKey,
      llm_google_key: llmGoogleKey,
      llm_anthropic_key: llmAnthropicKey,
      defaultImagePrompt,
      imageStyle,
      gsh,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    useImageAI,
    useAI,
    lang,
    llmModel,
    llmOpenAIKey,
    llmGoogleKey,
    llmAnthropicKey,
    defaultImagePrompt,
    imageStyle,
    useGSH,
  ]);

  const deleteItem = () => {
    api
      .deleteItem('project', projectId, t('projectForm.deletePrompt'))
      .then((result) => {
        projectStore.remove(projectId);
        window.location.href = ROUTES.projects;
      })
      .catch((e) => {});
  };

  const isOwner = () => sessionStore.role() === UserStatus.Owner;

  const updateProject = (event: React.FormEvent) => {
    const form = event.currentTarget as HTMLFormElement;
    if (form.checkValidity()) {
      setValidated(true);
      const data: TProjectLORE = {
        project_name: name.trim(),
        project_title: title.trim(),
        project_mg: mg.trim() || sessionStore.session.user_name,
        project_status: status,
        project_type: ProjectTypes.LORE,
        project_settings: JSON.stringify(settings),
        user_id: userId,
        // eslint-disable-next-line no-nested-ternary
        project_pricing: pricing || 'free',
      };
      if (projectId) data.project_id = projectId;
      api.setProject(data).then(async (res: TSuccessResponse) => {
        const { errors, success } = res;
        if (!errors) {
          if (projectId) {
            api.getProjects(projectId).then((projectData) => {
              let pd: TProjectLORE = projectData as TProjectLORE;
              if (pd.project_images?.length) {
                const [imgId, imgMime] = pd.project_images[0].split('.');
                pd = { img_id: +imgId, img_mime: imgMime, ...pd };
              }
              projectStore.update(pd);
              setRandom(Math.random());
            });
          } else if (success) {
            projectStore.add({ project_id: +success, ...data });
            setProjectId(+success);
            setRandom(Math.random());
          }
          await api.checkSession();
          console.log('OK');
          setSuccessText(projectId ? 'projectForm.editSuccess' : 'projectForm.createSuccess');
          timer = setTimeout(() => {
            setSuccessText('');
          }, 5000);
        }
      });
      event.preventDefault();
      event.stopPropagation();
    } else {
      event.preventDefault();
      event.stopPropagation();
    }

    return false;
  };

  const successAlert = successText ? <Alert variant='success'>{t(successText)}</Alert> : '';
  const roleBlock =
    isAdmin && roles?.length ? (
      <Row className='justify-content-md-center' style={{ marginTop: 24 }}>
        <Col xs lg={10}>
          <Row className='justify-content-md-center'>
            <Col>
              <h3>{t('projectForm.managers')}</h3>
            </Col>
          </Row>
          <Row className='justify-content-md-center'>
            <Col lg={11}>
              <UserFind action={setNewRoles} />
              <UserShow userId={newRoles} isSearch linkInDialog hideEmpty />
            </Col>
            <Col lg={1}>
              <Button
                variant='success'
                size='lg'
                onClick={() => {
                  if (newRoles && projectId)
                    api
                      .updateRole('add', newRoles, projectId, 'manager')
                      .then((result) => update())
                      .catch((e) => {});
                }}
              >
                <Plus fontSize={38} />
              </Button>
            </Col>
          </Row>
          {roles?.map((role: TUserRole) => (
            <Row
              key={role.user_id}
              className='justify-content-md-center mb-4'
              style={{
                border: '1px solid #00000022',
                borderRadius: 3,
                padding: 14,
                marginTop: 14,
                backgroundColor: '#fff',
              }}
            >
              <Col xs={3}>
                <UserShow userId={role.user_id} allUsers />
              </Col>
              <Col style={{ display: 'flex', alignItems: 'center' }}>{role.status}</Col>
              {role.user_id !== sessionStore.session.user_id ? (
                <Col style={{ display: 'flex', justifyContent: 'flex-end' }} xs={1}>
                  <Button
                    variant='danger'
                    size='sm'
                    style={{ height: 50, width: 50, fontSize: 20 }}
                    onClick={() => {
                      if (role.user_id && projectId)
                        api
                          .updateRole(
                            'delete',
                            role.user_id,
                            projectId,
                            '',
                            t('global.deletePrompt')
                          )
                          .then((result) => update());
                    }}
                  >
                    <Trash />
                  </Button>
                </Col>
              ) : (
                ''
              )}
            </Row>
          ))}
        </Col>
      </Row>
    ) : (
      ''
    );
  return (
    <Container fluid className='verticalPadding greenForm'>
      <Form onSubmit={updateProject} action='#' validated={validated}>
        <Row className='justify-content-md-center'>
          <Col xs lg={10}>
            <Stack direction='horizontal' gap={2}>
              <div>
                <h2>
                  {t(projectId ? 'projectForm.edit' : 'projectForm.create')}
                  {projectId ? <span className='text-muted'> #{projectId}</span> : ''}
                </h2>
              </div>
              {pricing || pricing === false ? (
                <div className='ms-auto'>
                  <Button variant='info' onClick={showPricingWindow}>
                    <CashCoin fontSize={20} />
                    &nbsp;&nbsp;{t(`pricing.pricing`)} <b>{t(`pricing.${pricing}.name`)}</b>
                  </Button>
                </div>
              ) : (
                ''
              )}
            </Stack>

            <FloatingLabel controlId='name' label={t('projectForm.name')} className='mb-3'>
              <Form.Control
                type='text'
                required
                size='lg'
                value={name || ''}
                onChange={(e) => setName(e.target.value)}
                placeholder={t('projectForm.name')}
              />
            </FloatingLabel>
            <FloatingLabel controlId='mg' label={t('projectForm.mg')} className='mb-3'>
              <Form.Control
                type='text'
                size='lg'
                value={mg || ''}
                onChange={(e) => setMG(e.target.value)}
                placeholder={t('projectForm.mg')}
              />
            </FloatingLabel>
            <FloatingLabel
              controlId='title'
              label={title ? '' : t('projectForm.title')}
              className='mb-3'
            >
              <Form.Control
                as='textarea'
                required
                rows={5}
                size='lg'
                value={title || ''}
                onChange={(e) => setTitle(e.target.value)}
                placeholder={t('projectForm.title')}
                style={{ height: '100px' }}
              />
              <AITextButton handler={onTitle} text={title} />
            </FloatingLabel>
            <FloatingLabel controlId='lang' label={t('projectForm.lang')} className='mb-3'>
              <Form.Select
                aria-label={t('projectForm.lang')}
                required
                size='lg'
                value={lang}
                onChange={(e) => setLang(e.currentTarget.value)}
              >
                <option value='ua'>Українська</option>
                <option value='en'>English</option>
              </Form.Select>
            </FloatingLabel>
            {successAlert}
          </Col>
        </Row>
        {canSave ? (
          <Row className='justify-content-md-center'>
            <Col xs lg={10}>
              <Alert variant='danger'>{t(canSave)}</Alert>
            </Col>
          </Row>
        ) : (
          ''
        )}
        <Row className='justify-content-md-center'>
          <Col lg={4}>
            <Row className='justify-content-md-center'>
              <Col xs={6}>
                <div className='d-grid gap-2'>
                  <Button
                    variant='primary'
                    disabled={!!canSave}
                    className='col-12'
                    size='lg'
                    type='submit'
                  >
                    {t(projectId ? 'global.save' : 'global.create')}
                  </Button>
                </div>
              </Col>
              <Col xs={6}>
                <div className='d-grid gap-2'>
                  <Link to={ROUTES.projects}>
                    <Button variant='secondary' className='col-12' size='lg'>
                      {t('global.back')}
                    </Button>
                  </Link>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
      {projectId ? (
        <>
          <Row className='justify-content-md-center mt-5'>
            <Col xs lg={10}>
              <Row className='justify-content-md-center'>
                {pricing !== 'free' ? (
                  <Col xs lg={6} className='mb-3'>
                    <Row className='justify-content-md-center'>
                      <Col xs lg={12}>
                        <h2>{t('projectForm.useAI')}</h2>
                      </Col>
                    </Row>
                    <Row className='justify-content-md-center'>
                      <Col xs lg={12}>
                        <Form.Check
                          type='switch'
                          key='openrequest'
                          name='type'
                          style={{ marginBottom: 20 }}
                          label={t('projectForm.openImageAI')}
                          checked={useImageAI || false}
                          onChange={(e: any) => setuseImageAI(e.target.checked)}
                        />
                      </Col>
                    </Row>
                    {useImageAI ? (
                      <Row className='justify-content-md-center'>
                        <Col xs lg={12} className='mb-3'>
                          <Row>
                            <Col xs lg={10}>
                              <FloatingLabel controlId='type' label={t('generation.style')}>
                                <Form.Select
                                  aria-label={t('generation.style')}
                                  required
                                  size='lg'
                                  value={imageStyle}
                                  onChange={(e) => setImageStyle(e.currentTarget.value)}
                                >
                                  <option key='none' value='none'>
                                    {t('generation.imageStyles.none')}
                                  </option>
                                  {stylesList.map((item) => (
                                    <option key={item} value={item}>
                                      {t(`generation.imageStyles.${item}`)}
                                    </option>
                                  ))}
                                </Form.Select>
                              </FloatingLabel>
                            </Col>
                          </Row>
                          <Row>
                            <Col xs lg={10}>
                              <FloatingLabel
                                controlId='defauldImagePrompt'
                                label={t('projectForm.defauldImagePrompt')}
                              >
                                <Form.Control
                                  type='text'
                                  required
                                  size='lg'
                                  value={defaultImagePrompt || ''}
                                  onChange={(e) => setDefaultImagePrompt(e.target.value)}
                                  placeholder={t('projectForm.defauldImagePrompt')}
                                />
                              </FloatingLabel>
                            </Col>
                            <Col xs lg={2}>
                              <InfoButton text='defaultImagePrompt' />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      ''
                    )}

                    <Row
                      className='justify-content-md-center'
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <Col xs lg={12}>
                        <Form.Check
                          type='switch'
                          key='useAI'
                          name='type'
                          style={{ marginBottom: 20 }}
                          label={t('projectForm.openAI')}
                          checked={useAI || false}
                          onChange={(e: any) => setUseAI(e.target.checked)}
                        />
                      </Col>
                    </Row>
                    {useAI ? (
                      <Row>
                        <Col xs lg={10}>
                          <FloatingLabel controlId='llmModel' label={t('projectForm.llmModel') || 'LLM Model'}>

                            <Form.Select
                              aria-label={t('projectForm.llmModel') || 'LLM Model'}
                              size='lg'
                              value={llmModel}
                              onChange={(e) => setLlmModel(e.target.value)}
                            >
                              <option value='none'>{t('projectForm.aiNone')}</option>
                              {modelList.map((m: any) => (
                                  m.value === 'none' ? '' : <option key={m.value} value={m.value}>{m.label}</option>
                              ))}
                            </Form.Select>
                          </FloatingLabel>
                      
                      {llmModel !== 'none' ? (
                        <Row>
                          <Col xs lg={12}>
                            {modelList.find(m => m.value === llmModel)?.provider === 'openai' && (
                                <FloatingLabel controlId='openAIKey' label={t('projectForm.openAIKey')}>
                                  <Form.Control
                                    type='text'
                                    required
                                    size='lg'
                                    value={llmOpenAIKey || ''}
                                    onChange={(e) => setLlmOpenAIKey(e.target.value)}
                                    placeholder={t('projectForm.openAIKey')}
                                  />
                                </FloatingLabel>
                            )}
                            {modelList.find(m => m.value === llmModel)?.provider === 'google' && (
                                <FloatingLabel controlId='googleKey' label={t('projectForm.googleKey') || 'Google API Key'}>
                                  <Form.Control
                                    type='text'
                                    required
                                    size='lg'
                                    value={llmGoogleKey || ''}
                                    onChange={(e) => setLlmGoogleKey(e.target.value)}
                                    placeholder={t('projectForm.googleKey') || 'Google API Key'}
                                  />
                                </FloatingLabel>
                            )}
                            {modelList.find(m => m.value === llmModel)?.provider === 'anthropic' && (
                                <FloatingLabel controlId='anthropicKey' label={t('projectForm.anthropicKey') || 'Anthropic API Key'}>
                                  <Form.Control
                                    type='text'
                                    required
                                    size='lg'
                                    value={llmAnthropicKey || ''}
                                    onChange={(e) => setLlmAnthropicKey(e.target.value)}
                                    placeholder={t('projectForm.anthropicKey') || 'Anthropic API Key'}
                                  />
                                </FloatingLabel>
                            )}
                          </Col>
                          {/*<Col xs lg={1}>
                            <InfoButton text='openAi' />
                          </Col>*/}
                          <Link
                            to={
                              api.settings.url.server +
                              'aiRobot/fullinfo/' +
                              projectId +
                              '?x=' +
                              sessionStore.session.user_session
                            }
                            target='_blank'
                          >
                            {t('projectForm.openAIInfo')}
                          </Link>
                        </Row>
                      ) : (
                        ' '
                      )}
                    </Col>
                  </Row>
                ) : (
                  ' '
                )}
              </Col>
              ) : (
                  ''
              )}
                <Col xs lg={6}>
                  {roleBlock}
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className='justify-content-md-center'>
            <Col xs lg={10}>
              <h2>{t('projectForm.images')}</h2>
            </Col>
          </Row>
          <Row className='justify-content-md-center mb-3'>
            <Col lg={10}>
              <ImageList
                id={projectId}
                type='project'
                genImgText={title}
                imgList={imgList}
                updateImagesHandle={updateImages}
                uploadUrl={'uploadProjectImage/' + projectId}
                random={random}
              />
            </Col>
          </Row>
          <Row className='justify-content-md-center'>
            <Col xs lg={10}>
              <h2>{t('projectForm.linkTexts')}</h2>
            </Col>
          </Row>
          <Row className='justify-content-md-center mb-3'>
            <Col lg={10}>
              <LinkList
                type='project'
                subType='text'
                id={projectId}
                storeName='projectLinks'
                title={t('text.mainTitle')}
                muteLoadFromAPI={false}
              />
            </Col>
          </Row>
          {isOwner() ? (
            <Row className='justify-content-md-center'>
              <Col lg={10} className='text-center'>
                <Button variant='danger' size='sm' onClick={() => deleteItem()}>
                  <Trash /> {t('projectForm.delete')}
                </Button>
              </Col>
            </Row>
          ) : (
            ''
          )}
        </>
      ) : (
        ''
      )}
    </Container>
  );
});

export default ProjectEdit;
